import styled, { css } from 'styled-components'
import React from 'react'

export const BusinessContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #02e5ff;
  color: #000;
`

export const BusinessBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  position: relative;

  ${({ bgimage }) => bgimage && css`
    width: 100%;
    height: calc(65vh - 98px);
    background-image: url(${bgimage});
    background-repeat: no-repeat, repeat;
    background-size: cover;
    object-fit: cover;
    background-position: center;

    @media (min-width: 450px) {
      height: 370px;
    }

    @media (min-width: 821px) {
      height: ${({ height, theme }) => theme?.business_listing_view?.components?.business_hero?.components?.styles?.height || height || '650px'};
    }
  `}

  @media (max-width: 576px) {
    margin-bottom: 0px;
  }
`

export const BusinessSearch = styled.div`
    display: flex;
    background-color: #333;
    align-items: center;
    padding: 7px;
    border-radius: 7px;
    font-size: 11px;
    color: #fff;
    svg {
      font-size: 15px;
      color: #fff;
    }
`

export const BusinessList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  @media (min-width: 768px) {
    padding: 0 30px;
  }
`

export const WrapperSearch = styled.div`
  margin: 10px 20px 0px;
  @media (min-width: 768px) {
    margin: 10px 40px 0px;
  }
  display: flex;
  justify-content: flex-end;
  a {
    text-decoration: none;
    width: 100%;
  }
  svg{
    align-self: center;
    cursor: pointer;
    font-size: 26px;
    color: ${props => props.theme?.colors?.primary};
    margin-left: 10px;
  }
  button {
    width: 250px;
    margin-left: 10px;
  }
  ${({ isCustomLayout, isCustomerMode }) => isCustomLayout && css`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;
    padding: 0 20px;
    @media (min-width: 768px) {
      padding: 0 40px;
    }
    ${isCustomerMode
      ? css`
      margin-right: 20px;
      @media (min-width: 768px) {
        margin-right: 40px;
      }
    `
      : css`
      margin: 0 auto;
    `}
    svg {
      align-self: auto;
    }

    @media(min-width: 681px){
      width: 75%;
      padding: 0;
    }

    @media(min-width: 1201px){
      width: 50%;
    }
  `}
`

export const ErrorMessage = styled.span`
  padding: 20px;
  width: 100%;
  background-color: #CCCCCC;
  margin: 0px 20px;
  @media (min-width: 768px) {
    margin: 0px 40px;
  }
  color: #D81313;
  font-weight: bold;
`

export const PreviousOrders = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 10px 20px 0px;
  @media (min-width: 768px) {
    margin: 10px 40px 0px;
  }
`

export const BusinessesTitle = styled.h1`
  color: #000;
  ${({ isCustomerMode }) => isCustomerMode
    ? css`
    font-size: 18px;
    margin: 0px 20px;
    @media (min-width: 768px) {
      margin: 0px 40px;
    }
  `
    : css`
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    margin: 42px 20px 5px 20px;
    @media (min-width: 768px) {
      margin: 42px 40px 5px 40px;
    }
  `}
`

export const HightestRatedWrapper = styled.div`
  padding: 50px 0 30px 0;
`

export const Divider = styled.div`
  background: #333;
  height: 8px;
  width: 100%;
`

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BusinessLogosWrapper = styled.div`
  overflow: scroll hidden;
  width: 100%;
`

const BusinessLogoStyled = styled.div`
  min-width: 100px;
  min-height: 100px;
  height: 100px;
  width: 100px;
  box-sizing: border-box;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  object-fit: cover;
  background-position: center;
  border-radius: 7.6px;
  margin-right: 15px;
  cursor: pointer;
  ${props => props.isActive && css`
    border: 2px solid ${props => props.theme.colors.primary};
  `};
`

export const BusinessLogo = (props) => {
  const style = {}
  if (props.bgimage) {
    style.backgroundImage = `url(${props.bgimage})`
  }

  return (
    <BusinessLogoStyled {...props} style={style}>
      {props.children}
    </BusinessLogoStyled>
  )
}
export const BusinessLogosContainer = styled.div`
  display: flex;
  padding-bottom: 10px;
`

export const HeaderSearchMode = styled.div`
  position: absolute;
  width: 200px;
`

export const AddressFormWrapper = styled.div`
  @media (min-width: 450px) {
    margin-top: 20px;
  }
`

export const IconTypeButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background: ${({ activated, theme }) => activated ? theme?.colors?.white : '#F3F9FF'};
  border-radius: 44px;
`

export const TypesContainer = styled.div`
  display: flex;
  margin: 42px 20px 0px 20px;
  @media (min-width: 768px) {
    margin: 42px 40px 0px 40px;
  }
`

export const AdditionalTypesContainer = styled.div`
  width: 60%;
  display: flex;
  margin-bottom: 20px;
  margin-left: 20px;
  @media (min-width: 768px) {
    margin-left: 40px;
  }
  button {
    padding: 4px 10px;
    border-radius: 50px;
    font-size: 10px;
    line-height: 0;
    height: 25px;
    margin-right: 20px;
  }
  .activated {
    color: ${({ theme }) => theme?.colors?.darkTextColor}
  }
`

export const TypeButton = styled.div`
  display: flex;
  align-items: center;
  width: 215px;
  height: 75px;
  border-radius: 7.6px;
  padding: 16px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
  margin-right: 32px;
  margin-bottom: 32px;
  cursor: pointer;
  background: ${({ activated, theme }) => activated ? theme?.colors?.primary : theme?.colors?.white};
  p{
    margin: 0;
    margin-left: 33px;
    ${({ activated, theme }) => activated && css`
      color: ${theme?.colors?.white};
    `}
  }
`

export const Title = styled.h2`
  font-weight: 600;
  font-size: 24px;
  color: #000;
  margin: 20px 20px 5px 20px;
  @media (min-width: 768px) {
    margin: 20px 40px 5px 40px;
  }
`

export const TypesWrapper = styled.div`
  margin-left: 20px;
  @media (min-width: 768px) {
    margin-left: 40px;
  }
  width: 600px;
`
